/**
 * Active ISO 4217 alphabetic codes — the canonical membership check for
 * currency slots, shared by server validation and the create-account modal.
 *
 * Deliberately NOT Intl.supportedValuesOf('currency'): that enumerates the
 * runtime's ICU locale data, which both lags the registry (Node 22 is
 * missing VED, the funds codes BOV/CHE/CHW/COU/MXV/USN/UYI/UYW, and the
 * X-codes) and keeps withdrawn codes (HRK, CUC, SLL, ZWL) — and it can
 * differ between the browser and the server, so the two would accept
 * different sets. This list is the registry's active table; update it on
 * the rare ISO amendment. Withdrawn since the last audit and therefore
 * absent: HRK (EUR, 2023), CUC (2021), SLL (SLE, 2024), ZWL (ZWG, 2024),
 * ANG (XCG, 2025), BGN (EUR, 2026). Also deliberately absent despite being registry
 * entries: XTS (testing) and XXX (no currency) — neither can denominate a
 * real account.
 */
const ACTIVE_ISO_4217 = [
  'AED', 'AFN', 'ALL', 'AMD', 'AOA', 'ARS', 'AUD', 'AWG', 'AZN',
  'BAM', 'BBD', 'BDT', 'BHD', 'BIF', 'BMD', 'BND', 'BOB', 'BOV',
  'BRL', 'BSD', 'BTN', 'BWP', 'BYN', 'BZD', 'CAD', 'CDF', 'CHE', 'CHF',
  'CHW', 'CLF', 'CLP', 'CNY', 'COP', 'COU', 'CRC', 'CUP', 'CVE',
  'CZK', 'DJF', 'DKK', 'DOP', 'DZD', 'EGP', 'ERN', 'ETB', 'EUR', 'FJD',
  'FKP', 'GBP', 'GEL', 'GHS', 'GIP', 'GMD', 'GNF', 'GTQ', 'GYD', 'HKD',
  'HNL', 'HTG', 'HUF', 'IDR', 'ILS', 'INR', 'IQD', 'IRR', 'ISK',
  'JMD', 'JOD', 'JPY', 'KES', 'KGS', 'KHR', 'KMF', 'KPW', 'KRW', 'KWD',
  'KYD', 'KZT', 'LAK', 'LBP', 'LKR', 'LRD', 'LSL', 'LYD', 'MAD', 'MDL',
  'MGA', 'MKD', 'MMK', 'MNT', 'MOP', 'MRU', 'MUR', 'MVR', 'MWK', 'MXN',
  'MXV', 'MYR', 'MZN', 'NAD', 'NGN', 'NIO', 'NOK', 'NPR', 'NZD', 'OMR',
  'PAB', 'PEN', 'PGK', 'PHP', 'PKR', 'PLN', 'PYG', 'QAR', 'RON', 'RSD',
  'RUB', 'RWF', 'SAR', 'SBD', 'SCR', 'SDG', 'SEK', 'SGD', 'SHP', 'SLE',
  'SOS', 'SRD', 'SSP', 'STN', 'SVC', 'SYP', 'SZL', 'THB', 'TJS',
  'TMT', 'TND', 'TOP', 'TRY', 'TTD', 'TWD', 'TZS', 'UAH', 'UGX', 'USD',
  'USN', 'UYI', 'UYU', 'UYW', 'UZS', 'VED', 'VES', 'VND', 'VUV', 'WST',
  'XAF', 'XAG', 'XAU', 'XBA', 'XBB', 'XBC', 'XBD', 'XCD', 'XCG', 'XDR',
  'XOF', 'XPD', 'XPF', 'XPT', 'XSU', 'XUA', 'YER', 'ZAR', 'ZMW', 'ZWG',
] as const;

export const ISO_4217_CODES: ReadonlySet<string> = new Set(ACTIVE_ISO_4217);
